module.exports = __webpack_public_path__ + "img/hr-rock-medium-11.d16d367d.png";